import { render, staticRenderFns } from "./svgProperties.vue?vue&type=template&id=3f95a4d4&"
import script from "./svgProperties.vue?vue&type=script&lang=js&"
export * from "./svgProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports